import React from 'react';
import {useDispatch} from 'react-redux';
import {useFullVariantByIdSsr} from '../../../../api/hooks/useFullVariantByIdSsr.hook';
import {useInstanceDetailPage} from '../../../../api/hooks/useInstanceDetail.hook';
import {InstanceStatus} from '../../../../api/models/instance-status';
import {mintInstance} from '../../../../redux/slices/mint-slice';
import {TypographyVariantsEnum} from '../../../../utils/_enums/typeography-variants.enum';
import {getLocaleEthPrice} from '../../../../utils/_helper/locale-helper';
import {useAppSelector} from '../../../../utils/_hooks/hooks';
import {Button} from '../../button/button';
import {Typography} from '../../typography/typography';
import TransactionFeeBox from '../_shared/transaction-fee-box/transaction-fee-box';
import SalesBoxConnectWallet from '../connect-wallet/sales-box-connect-wallet';
import styles from './minting-box.module.scss';

const MintingBox = () => {
    const dispatch = useDispatch();

    const data = useInstanceDetailPage();
    const variant = useFullVariantByIdSsr();

    const {
        walletId,
        balance,
        instance,
        chainId,
        mintInstanceModel
    } = useAppSelector((state) => ({
        walletId: state.blockchainSlice.walletId,
        balance: state.blockchainSlice.balance,
        instance: state.productSlice.instance,
        chainId: state.blockchainSlice.chainId,
        mintInstanceModel: state.mintSlice.mintInstanceModel
    }));

    if (data) {
        if (instance?.status === InstanceStatus.MINTING) {
            return (
                <div className={styles['minting-box']}>
                    <div>
                        <Typography>{data?.currentlyMinting?.content}</Typography>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={styles['minting-box']}>
                    <Typography
                        variant={TypographyVariantsEnum.BODY_SMALL}
                        className={styles['minting-description-general']}
                    >
                        {data?.mintingDescriptionGeneral?.content ?? ''}
                    </Typography>
                    {walletId ? (
                        <>
                            <Typography className={styles['wallet-connected-text']}
                                        variant={TypographyVariantsEnum.BODY_SMALL}>
                                {data?.walletConnectedText?.content ?? ''}
                            </Typography>
                            <div>
                                <Typography
                                    variant={TypographyVariantsEnum.BODY_SMALL}
                                >{`${data?.walletId ?? ''}:`}</Typography>
                                <Typography
                                    variant={TypographyVariantsEnum.BODY_SMALL}
                                    className={styles['bold-text']}
                                >
                                    {walletId}
                                </Typography>
                            </div>
                            <div>
                                <Typography
                                    variant={TypographyVariantsEnum.BODY_SMALL}
                                >
                                    {data?.availableText ?? ''}
                                </Typography>
                                <Typography
                                    variant={TypographyVariantsEnum.BODY_SMALL}
                                    className={styles['bold-text']}
                                >
                                    {balance !== undefined
                                        ? getLocaleEthPrice(balance) + 'Ξ'
                                        : ''}
                                </Typography>
                            </div>
                            <TransactionFeeBox gasUsage={87000}/>
                            <div>
                                {
                                    <Typography
                                        variant={TypographyVariantsEnum.BODY_SMALL}
                                        className={styles['error-message']}
                                    >
                                        {chainId !== Number(process.env.NEXT_PUBLIC_CHAIN_ID)
                                            ? data?.networkErrorMessage ?? ''
                                            : !balance
                                                ? data?.mintingErrorMessage ?? ''
                                                : ''}
                                    </Typography>
                                }
                                <Button
                                    className={styles['mint-nft-button']}
                                    disabled={!balance || chainId !== Number(process.env.NEXT_PUBLIC_CHAIN_ID)}
                                    pending={mintInstanceModel.pending}
                                    onClick={() => {
                                        if (instance && variant) {
                                            dispatch(
                                                mintInstance({
                                                    tokenContractAddress: variant.salesAttribute?.contract?.contractAddress ?? '',
                                                    instanceId: instance.id,
                                                    walletAddress: walletId
                                                })
                                            );
                                        }
                                    }}
                                >
                                    {data?.mintNFT?.buttonText ?? ''}
                                </Button>
                            </div>
                        </>
                    ) : (
                        <div>
                            <SalesBoxConnectWallet/>
                        </div>
                    )}
                </div>
            );
        }
    } else {
        return <div/>;
    }
};

export default MintingBox;
